/** @file prefixOf: the name prefix of the attachment at an index (`att<i>.`, ruling R1). */

/** `att<index>.`; flattened nodes, drawables, sheets and clips of attachment `index` start with it. */
export function prefixOf(index: number): string {
  return `att${String(index)}.`;
}
